import { z } from 'zod';

import { OpIdSchema, type OpId } from './op-id.js';

/**
 * The predecessor op id the writer was based on, or `null` for the first
 * op on a (subject, predicate) chain. The server validates `base_version`
 * against the current head; a mismatch is a stale write and surfaces as
 * draft-with-conflict (02-architecture.md §4.1).
 */
export type BaseVersion = OpId | null;

export const BaseVersionSchema = z.union([OpIdSchema, z.null()]);
